import { createTheme } from "@mui/material";
import { InterfaceConfig, AmplifyConfig } from "@interfaces/response";
import { themeBase } from "./_themeBase";

export const CustomTheme = createTheme(themeBase, {
  palette: {
    primary: {
      main: "#004C89",
      dark: "#003A63",
      light: "#F3C500",
    },
    secondary: {
      main: "#F2704F",
    },
    backgroundRight: {
      main: "#004C89",
      dark: "#003A63",
      light: "#F3C500",
      tab: "#FFF9E9",
    },
    phoneInput: {
      main: "#E3F2F8",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#003A63",
      tabText: "#FFFFFF",
      tabBackground: "#003A63",
      menuIcon: "#004C89",
    },
    barProgress: {
      main: "#F3C500",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#D8D8D8D8",
      barColor: "#004C89",
      iconColor: "#F3C500",
      markLabelColor: "#004C89",
    },
    buttonSelected: {
      backgroundColor: "#D8D8D8D8",
      backgroundColorActive: "#004C89",
      textColor: "#004C89",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#528CD640",
    },
    screenBackground: {
      backgroundColor: "#003A63",
      textColor: "#F3C500",
      subTextColor: "#FFFFFF",
      iconColor: "#F3C500",

      backgroundColorBofu: "#003A63",
      textColorBofu: "#F3C500",
      subTextColorBofu: "#FFFFFF",
      iconColorBofu: "#F3C500",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#F3C500",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#F3C500",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#F3C500",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#004C89",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#004C89",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#003A63",
              color: "#F3C500",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#004C89",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#004C89",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },

        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#004C89",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#003A63",
            backgroundColor: "#FFF",
            border: "2px solid #003A63",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#F3C500",
            color: "#FFFFFF",
            backgroundColor: "#003A63",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#003A63",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#003A63",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#004C89",
            backgroundColor: "#F3C500",
            "&.Mui-disabled": {
              backgroundColor: "#F3C500",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F3C500",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#004C89",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#004C89",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#003A63",
              color: "#F3C500",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#F3C500", // Borde azul cuando no está enfocado
              borderRadius: "5px",
            },
            "&:hover fieldset": {
              borderColor: "#F3C500", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#F3C500", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#F3C500", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#F3C500",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#F3C500",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#003A63",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "avanza_solido",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: "/aviso_de_privacidad",
  terminos_condiciones: "/terminos_y_condiciones",
  interest_rate: 30,
  metadata: {
    title: "Avanza Solido",
    description:
      "Avanza Solido es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "avanza_solido/portal/logos/favicon.ico",
  },
  navbar: {
    logo: "avanza_solido/portal/logos/logo_dark.png",
    logo_width: 142,
    logo_height: 36,
  },
  lateral: {
    logo_light: "avanza_solido/portal/logos/logo_light_bg.png",
    bg_light: CustomTheme.palette.primary.light, // #F3C500
    text_light: "#FFFFFF",
    logo_dark: "avanza_solido/portal/logos/logo_dark_bg.png",
    bg_dark: CustomTheme.palette.primary.dark, // #003A63
    text_dark: "#FFFFFF",
    image_list: [
      "avanza_solido/portal/lateral/agro_1.webp",
      "avanza_solido/portal/lateral/agro_2.webp",
      "avanza_solido/portal/lateral/agro_3.webp",
      "avanza_solido/portal/lateral/agro_4.webp",
      "avanza_solido/portal/lateral/agro_5.webp",
      "avanza_solido/portal/lateral/agro_6.webp",
      "avanza_solido/portal/lateral/agro_7.webp",
      "avanza_solido/portal/lateral/agro_8.webp",
      "avanza_solido/portal/lateral/agro_9.webp",
      "avanza_solido/portal/lateral/agro_10.webp",
    ],
    text_list: [
      "Haz crecer el campo con financiamiento",
      "Financiamiento ágil para productores mexicanos",
      "Siembra hoy, cosecha oportunidades",
      "Crédito confiable para las empresas productoras",
      "Apoyamos tu esfuerzo con crédito sólido",
      "Siembra hoy el crecimiento de tu empresa",
      "Impulsa tu negocio, fortalece tu futuro",
      "Más recursos para negocios que no se detienen",
      "Apoyamos tu esfuerzo con soluciones reales",
      "Avanza con crédito pensado para ti",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo:
          "En caso de tener mas de un accionista en igualdad de acciones, \ningresar al que además funja como Representante Legal",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: [
    "Avanza Solido SA de CV, SOFOM ENR",
    "Cumplo y Avanzo SAPI de CV, SOFOM ENR",
    "Lendit Group SAPI de CV",
  ],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  scripts: {
    tag_id_hotjar: "6487607",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_k3I2MPdol",
      userPoolClientId: "42thusp2dfnk9j211mmscvtp84",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Usx5xKDDn",
      userPoolClientId: "vvta97uqr6l5eqke0ajeu24r4",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
